import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { isParent, LastModifiedCell, RowExpanderColumn } from 'components/Table'
import { COLUMN_SIZE } from 'components/Table/constants'
import ActionsCell from '../components/ActionsCell'
import { WorkspaceDomainAlerts } from '../hooks/useGetFreshWorkspaceDomainAlerts'
import { WorkspaceForTable } from '../types'
import { AlertsCell } from './AlertsCell'
import { PipedriveNavLink } from './PipedriveNavLink'
import { StatusSwitch } from './StatusSwitch/StatusSwitch'

type Props = {
  workspaceDomainAlerts: WorkspaceDomainAlerts[]
}

export const useColumns = ({ workspaceDomainAlerts }: Props): ColumnDef<WorkspaceForTable>[] => {
  const { t } = useTranslation('features/workspace')

  return [
    RowExpanderColumn<WorkspaceForTable>(),
    {
      accessorKey: 'name',
      header: t('list.header.name'),
    },
    {
      accessorKey: 'domains',
      header: t('list.header.domains'),
    },
    {
      accessorKey: 'alerts',
      cell: ({ row }) => (
        <AlertsCell
          {...row}
          workspaceDomainAlerts={workspaceDomainAlerts}
        />
      ),
      header: t('list.header.alerts'),
      meta: { nonClickable: true },
    },
    {
      accessorKey: 'networkCode',
      header: t('list.header.networkCode'),
    },
    {
      accessorKey: 'crmId',
      header: t('list.header.crmId'),
    },
    {
      accessorKey: 'pipedriveLink',
      cell: ({ row }) => <PipedriveNavLink {...row} />,
      header: t('list.header.pipedrive'),
      meta: { nonClickable: true },
    },
    {
      accessorKey: 'active',
      cell: ({ row }) => <StatusSwitch {...row} />,
      header: t('list.header.active'),
      meta: { nonClickable: true },
    },
    {
      accessorKey: 'updatedAt',
      cell: props => <LastModifiedCell {...props} />,
      header: t('list.header.lastModified'),
    },
    {
      cell: ({ row }) => isParent(row) && <ActionsCell {...row.original} />,
      header: t('list.header.actions'),
      id: 'actions',
      meta: {
        centered: true,
        nonClickable: true,
      },
      size: COLUMN_SIZE.SM,
    },
  ]
}
